<div class="btn-group">
  <app-select (ngModelChange)="onUserChanged($event)" [options]="mockProfiles" [(ngModel)]="appContext.userProfile"
              dataKey="organisation.contact" (click)="$event.stopPropagation()" id="user-options"></app-select>
</div>
